export default {
  payrollFrequency: {
    isRequiredTrim: {
      value: true,
    },
  },
  year: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/payrollDeductions/payrollDeductionsValidationRules.js